/*
  File: src/api/players.js
  Purpose: Players API client with CRUD helpers (list, create, get, update, delete)
  Notes:
  - Uses shared apiClient base URL and credentials.
  - Supports JSON and multipart/form-data for image upload as data URL or File.
*/
import { apiClient } from '../auth/api';

function buildFormData(payload) {
    const fd = new FormData();
    const { names, display_name, team_id, position, image_url, image } = payload || {};
    if (names != null && Array.isArray(names)) fd.append('names', JSON.stringify(names));
    if (display_name != null) fd.append('display_name', display_name);
    if (team_id != null) fd.append('team_id', String(team_id));
    if (position != null) fd.append('position', position);
    if (image_url != null) fd.append('image_url', image_url);
    if (image != null) fd.append('image', image);
    return fd;
}

export const PlayersAPI = {
    async list({ limit = 50, offset = 0 } = {}) {
        const params = {};
        if (limit != null) params.limit = limit;
        if (offset != null) params.offset = offset;
        const { data } = await apiClient.get('/players', { params });
        return data;
    },

    async create(payload, { useMultipart = true } = {}) {
        if (useMultipart) {
            const form = buildFormData(payload);
            const { data } = await apiClient.post('/players', form, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            return data;
        }
        const { data } = await apiClient.post('/players', payload);
        return data;
    },

    async getById(playerId) {
        const { data } = await apiClient.get(`/players/${playerId}`);
        return data;
    },

    async update(playerId, payload, { useMultipart = true } = {}) {
        if (useMultipart) {
            const form = buildFormData(payload);
            const { data } = await apiClient.put(`/players/${playerId}`, form, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            return data;
        }
        const { data } = await apiClient.put(`/players/${playerId}`, payload);
        return data;
    },

    async remove(playerId) {
        const { data } = await apiClient.delete(`/players/${playerId}`);
        return data;
    }
};

export default PlayersAPI;

